import "./ContactForm.css";

import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useCartContext } from "../../../hooks/useCartContext";
import { apiFetch } from "../../../utils/api";
import Button from "../../Button/Button";

const ContactForm = () => {
  const { t } = useTranslation();
  const { items: cartItems, clearCart } = useCartContext();
  const [status, setStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const name = form.name.value.trim();
    const email = form.email.value.trim();
    const subject = form.subject.value.trim();
    const message = form.message.value.trim();

    setStatus({ type: "pending" });
    try {
      const res = await apiFetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name,
          email,
          subject,
          message,
          itemIds: cartItems.map((i) => i.id),
        }),
      });

      if (!res.ok) {
        let errorMsg = t("contact.form.errorMessage");
        try {
          const data = await res.json();
          if (data && data.error) errorMsg = data.error;
        } catch {}
        setStatus({ type: "error", message: errorMsg });
        return;
      }

      setStatus({ type: "success", message: t("contact.form.successMessage") });
      form.reset();
      clearCart();
    } catch {
      setStatus({ type: "error", message: t("contact.form.errorMessage") });
    }
  };

  return (
    <form onSubmit={handleSubmit} className="contact-us-form">
      <div className="form-group">
        <label htmlFor="name">{t("contact.form.name")}</label>
        <input id="name" name="name" placeholder={t("contact.form.name")}
          required autoComplete="name" />
      </div>
      <div className="form-group">
        <label htmlFor="email">{t("contact.form.email")}</label>
        <input id="email" name="email" type="email" placeholder={t("contact.form.email")}
          required autoComplete="email" />
      </div>
      <div className="form-group">
        <label htmlFor="subject">{t("contact.form.subject")}</label>
        <input id="subject" name="subject" placeholder={t("contact.form.subject")}
          required />
      </div>

      {cartItems.length > 0 && (
        <div className="contact-cart-summary">
          <div className="contact-cart-summary-title">{t('contact.form.enquiryIncludes')}</div>
          <ul className="contact-cart-summary-list">
            {cartItems.map((item) => (
              <li key={item.id}>
                <Link to={`/catalog/item/${item.id}`} className="contact-cart-summary-link">
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}

      <div className="form-group">
        <label htmlFor="message">{t("contact.form.message")}</label>
        <textarea id="message" name="message" placeholder={t("contact.form.message")}
          required rows={5} />
      </div>
      <Button variant="primary" type="submit" disabled={status?.type === "pending"}>
        {status?.type === "pending" ? t("contact.form.sendingButton") || "Sending..." : t("contact.form.sendButton")}
      </Button>
      {status?.type === "error" && (
        <div className="form-message error">{status.message}</div>
      )}
      {status?.type === "success" && (
        <div className="form-message success">{status.message}</div>
      )}
    </form>
  );
};

export default ContactForm;
